<ng-template #popover>
  <popover-container>
    <div class="help-menu">
      <div class="item-menu">
        <div class="icon-item"></div>
        <div class="text-item">{{ 'Help.UneQuestion' | translate }}</div>
      </div>
      <div class="item-menu">
        <div class="icon-item"></div>
        <div class="text-item">{{ 'Help.Contact' | translate }}</div>
      </div>
      <div class="item-menu small-item" (click)="handlePhone('+33756998425')">
        <div class="icon-item">
          <img src="assets/images/phone-help.svg" />
        </div>
        <div class="text-item">
          <span>{{ 'Help.Phone' | translate }} </span>
          <span>+ 33 7 56 99 84 25</span>
        </div>
      </div>
      <div
        class="item-menu small-item"
        (click)="handleEmail('mailto:info@alkesoccer.com')"
      >
        <div class="icon-item">
          <img src="assets/images/email-help.svg" />
        </div>
        <div class="text-item">
          <span>{{ 'Help.Email' | translate }} </span>
          <span>info@alkesoccer.com</span>
        </div>
      </div>
    </div>
  </popover-container>
</ng-template>
<div class="header">
  <span>{{ 'MyAlke' | translate }}</span>
  <img src="assets/images/logo.svg" alt="logo" (click)="goHome()" />
  <div class="right">
    <div class="help-header">
      <span>
        {{ 'Help.Title' | translate }}
      </span>
      <img
        src="assets/images/help_button.svg"
        [popoverTrigger]="popover"
        [closeOnClickOutside]="true"
      />
    </div>
  </div>
  <ul class="link">
    <li (click)="changeLanguage('fr')" [ngClass]="{ current: locale === 'fr' }">
      <div class="lang-img">
        <img
          src="https://alkesoccer.com/img/l/1.jpg"
          alt="fr"
          width="20"
          height="11"
        />
      </div>
    </li>
    <li
      style="margin-left: 10px"
      (click)="changeLanguage('en')"
      [ngClass]="{ current: locale === 'en' }"
    >
      <div class="lang-img">
        <img
          src="https://alkesoccer.com/img/l/2.jpg"
          alt="en"
          width="20"
          height="11"
        />
      </div>
    </li>
  </ul>
</div>
